import React from "react";

export default function ProfileSmallButton({label, disabled, selected, onSelect}) {
return (
    <button className={"btn btn-outline-secondary btn-sm" + (selected ? " active" : "")} disabled={disabled} onClick={onSelect}>{label}</button>
)
}